import { c as _c } from "react/compiler-runtime";
import { UFBNoticeButton } from '@udemy-v2/organization-growth';
import styles from './teams-purchase-slider-menu-content.module.scss';
import { useUbCtaParams } from '@/features/course-landing-page/hooks/use-ub-cta-href';
export const TeamsPurchaseSliderMenuContent = () => {
  const $ = _c(2);
  const {
    ubHref
  } = useUbCtaParams();
  let t0;
  if ($[0] !== ubHref) {
    t0 = <UFBNoticeButton className={styles.button} href={ubHref} size="large" />;
    $[0] = ubHref;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};